/**
 * Forms validation (for usage in global scope)
 *
 * @example
 *  if (typeof ValidateFormField !== 'undefined') {
 *      // Create new instance of object
 *      const isValidField = new ValidateFormField();
 *
 *      const fieldObj = your_field; // Js-object (not jquery-object)
 *
 *      // Access to custom method ".validate"
 *      if ( isValidField.validate && !isValidField.validate(fieldObj) ) {...your_code...}
 *  }
 */
const ValidateFormField = function() {
    /**
     * Validation by field's "name" attribute
     *
     * @param {Object} field - Field's js-object.
     */
    this.validate = function (field) {
        const fieldName = field.name;
        const fieldVal = field.value;
        const fieldError = field.parentNode.querySelector('.b-field-tooltip'); // Related error-container

        if (fieldName === 'user_name') {
            // console.log(fieldVal);

            if (fieldVal === '' && field.required) {
                fieldError.classList.add('js-active');
                fieldError.innerHTML = this.errors.defaultName;
                return false;
            }
            else if (fieldVal !== '' && fieldVal.length < 2) {
                fieldError.classList.add('js-active');
                fieldError.textContent = this.errors.invalidLength;
                return false;
            }
            else {
                fieldError.classList.remove('js-active');
                return true;
            }
        }
        else if (fieldName === 'user_company') {
            // console.log(fieldVal);

            if (fieldVal === '' && field.required) {
                fieldError.classList.add('js-active');
                fieldError.innerHTML = this.errors.defaultCompany;
                return false;
            }
            else if (fieldVal !== '' && fieldVal.length < 2) {
                fieldError.classList.add('js-active');
                fieldError.textContent = this.errors.invalidLength;
                return false;
            }
            else {
                fieldError.classList.remove('js-active');
                return true;
            }
        }
        else if (fieldName === 'user_post') {
            // console.log(fieldVal);

            if (fieldVal === '' && field.required) {
                fieldError.classList.add('js-active');
                fieldError.innerHTML = this.errors.defaultPost;
                return false;
            }
            else if (fieldVal !== '' && fieldVal.length < 2) {
                fieldError.classList.add('js-active');
                fieldError.textContent = this.errors.invalidLength;
                return false;
            }
            else {
                fieldError.classList.remove('js-active');
                return true;
            }
        }
        else if (fieldName === 'user_message') {
            // console.log(fieldVal);

            if (fieldVal === '' && field.required) {
                fieldError.classList.add('js-active');
                fieldError.textContent = this.errors.required;
                return false;
            }
            else if (fieldVal !== '' && fieldVal.length < 2) {
                fieldError.classList.add('js-active');
                fieldError.textContent = this.errors.invalidLength;
                return false;
            }
            else {
                fieldError.classList.remove('js-active');
                return true;
            }
        }
        else if (fieldName === 'user_phone') {
            // console.log(fieldVal);

            if (fieldVal === '' && field.required) {
                fieldError.classList.add('js-active');
                fieldError.innerHTML = this.errors.defaultPhone;
                return false;
            }
            else if (fieldVal !== '' && !this.checkIsPhoneValid(fieldVal)) {
                fieldError.classList.add('js-active');
                fieldError.textContent = this.errors.invalidPhone;
                return false;
            }
            else {
                fieldError.classList.remove('js-active');
                return true;
            }
        }
        else if (fieldName === 'user_email') {
            // console.log(fieldVal);

            if (fieldVal === '' && field.required) {
                fieldError.classList.add('js-active');
                fieldError.innerHTML = this.errors.defaultEmail;
                return false;
            }
            else if (fieldVal !== '' && !this.checkIsEmailValid(fieldVal)) {
                fieldError.classList.add('js-active');
                fieldError.textContent = this.errors.invalidEmail;
                return false;
            }
            else {
                fieldError.classList.remove('js-active');
                return true;
            }
        }
        else if (fieldName === 'user_site') {
            // console.log(fieldVal);

            if (fieldVal === '' && field.required) {
                fieldError.classList.add('js-active');
                fieldError.innerHTML = this.errors.defaultSite;
                return false;
            }
            else if (fieldVal !== '' && !this.checkIsSiteValid(fieldVal)) {
                fieldError.classList.add('js-active');
                fieldError.textContent = this.errors.invalidSite;
                return false;
            }
            else {
                fieldError.classList.remove('js-active');
                return true;
            }
        }
        else {
            return true;
        }
    };


    /**
     * Validation patterns
     *
     * @param {string} fieldVal - Field's value
     */

    // phone
    this.checkIsPhoneValid = function(fieldVal) {
        const patternBel = new RegExp(/^(\+?(375|8)[\s]?)(\(?(17|162|163|1644|165|1655|212|2151|2156|2157|214|232|2334|2351|2342|152|1512|1561|1592|1514|177|1771|1772|1775|1773|1795|174|1717|222|2232|225|2231|2233|2248|2237|2244|2236|2245|2238|2241|2234|2240|2235|2246|2247|2242|2243|2239|33|44|25|29|0(17|162|163|1644|165|1655|212|2151|2156|2157|214|232|2334|2351|2342|152|1512|1561|1592|1514|177|1771|1772|1775|1773|1795|174|1717|222|2232|225|2231|2233|2248|2237|2244|2236|2245|2238|2241|2234|2240|2235|2246|2247|2242|2243|2239|25|29|33|44))\)?[\s]?)(\d{2,3}[-\s]?)(\d{2}[-\s]?){2}$/i)
        const  patternRus = new RegExp(/^(\+?(7)[\s]?)(\(?\d{3}\)?[\s]?)(\d{3}[-\s]?)(\d{2}[-\s]?){2}$/i)
        const  patternIntern = new RegExp(/^\+?[0-9 \-\(\)]{6,}$/i)

        if (fieldVal.startsWith('+375') || fieldVal.startsWith('375') || fieldVal.startsWith('+80') || fieldVal.startsWith('80')) {
            return patternBel.test(fieldVal);
        }

        else if (fieldVal.startsWith('+7') || fieldVal.startsWith('7')) {
            return patternRus.test(fieldVal);
        }

        else  {
            return patternIntern.test(fieldVal);
        }
    };

    // email
    this.checkIsEmailValid = function(fieldVal) {
        const pattern = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
        return pattern.test(fieldVal);
    };

    // site-link
    this.checkIsSiteValid = function(fieldVal) {
        //const pattern = new RegExp(/^(([а-яёa-z0-9]{1})((\.[а-яёa-z0-9-])|([а-яёa-z0-9-]))*\.([а-яёa-z]{2,7})(\/?)$)/i);
        const pattern = new RegExp(/^(?:(?:https?|http):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/);
        return pattern.test(fieldVal);
    };


    /** Errors templates */
    this.errors = {
        // Default
        defaultName: '<span>Например:</span>Иванов Иван Иванович',
        defaultEmail: '<span>Например:</span>mail@site.com',
        defaultPhone: '<span>Например:</span>+375 29 000 00 00',
        defaultSite: '<span>Например:</span>site.com',
        defaultCompany: '<span>Например:</span>ООО "Самая лучшая фирма"',
        defaultPost: '<span>Например:</span>Директор',
        // Invalid
        invalidLength: 'Введите не менее 2-ух символов',
        invalidPhone: 'Неверный формат телефона',
        invalidEmail: 'Неверный формат email',
        invalidSite: 'Неверный формат сайта',
        // Required
        required: 'Обязательное поле'
    };
};